import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions-employee',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './terms-conditions-employee.component.html',
  styleUrl: './terms-conditions-employee.component.css'
})
export class TermsConditionsEmployeeComponent implements OnInit {
  
  constructor(private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle('Terms and Conditions');
  }
}